var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('portal',{attrs:{"to":"app-header"}},[_c('v-btn',{staticClass:"mb-1",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('span',[_vm._v("New Production Order")])],1),_c('SalesForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }